export const ORDER_FILTER_TYPE_KEYS = {
  DUE_ORDERS: ["due", "today", "overdue"],
  OPEN_ORDERS: ["open", "pending"],
  ALL_ORDERS: ["all", "total"],
  COMPLETED_ORDERS: [
    "completed",
    "delivered",
    "shipped",
    "zugestellt",
    "versendet",
  ],
  CANCELED_ORDERS: ["canceled", "cancelled", "storniert"],
  NOT_ACCEPTED_ORDERS: ["notaccepted", "not_accepted", "notacceptedorder"],
  DOCUMENT_NOT_CREATED_ORDERS: ["documentnotcreated", "document_not_created"],
  DOCUMENT_NOT_COLLECTED_ORDERS: [
    "documentnotcollected",
    "document_not_collected",
  ],
  READY_FOR_DISPATCH_ORDERS: [
    "readyfordispatch",
    "ready_for_dispatch",
    "versandfertig",
  ],
  SHIPPING_LABEL_NOT_UPLOADED_ORDERS: [
    "shippinglabelnotupload",
    "shipping_label_not_upload",
  ],
  UPLOAD_INVOICE_BILL_ORDERS: ["uploadinvoicebill", "upload_invoice_bill"],
  UPLOAD_BILL_ORDERS: ["uploadbill", "upload_bill"],
  RECEIPT_BILL_UPLOAD_ORDERS: ["receiptbillupload", "receipt_bill_upload"],
  RECEIPT_UPLOAD_ORDERS: ["receiptupload", "receipt_upload"],
  ORDER_RECEIPT_MISSING_ORDERS: [
    "orderreceiptmissing",
    "order_receipt_missing",
  ],
  ALL_MIRAKL_ORDERS: ["allmirakl"],
  MIRAKL_AWAITING_SHIPMENT_ORDERS: ["miraklawaitingshipment"],
};

export const ORDER_FILTER_TYPES = {
  ALL_ORDERS: "ALL_ORDERS",
  OPEN_ORDERS: "OPEN_ORDERS",
  DUE_ORDERS: "DUE_ORDERS",
  ALL_EBAY_ORDERS: "ALL_EBAY_ORDERS",
  ALL_MIRAKL_ORDERS: "ALL_MIRAKL_ORDERS",
  COMPLETED_ORDERS: "COMPLETED_ORDERS",
  CANCELED_ORDERS: "CANCELED_ORDERS",
  NOT_ACCEPTED_ORDERS: "NOT_ACCEPTED_ORDERS",
  DOCUMENT_NOT_CREATED_ORDERS: "DOCUMENT_NOT_CREATED_ORDERS",
  DOCUMENT_NOT_COLLECTED_ORDERS: "DOCUMENT_NOT_COLLECTED_ORDERS",
  READY_FOR_DISPATCH_ORDERS: "READY_FOR_DISPATCH_ORDERS",
  SHIPPING_LABEL_NOT_UPLOADED_ORDERS: "SHIPPING_LABEL_NOT_UPLOADED_ORDERS",
  UPLOAD_BILL_ORDERS: "UPLOAD_BILL_ORDERS",
  UPLOAD_INVOICE_BILL_ORDERS: "UPLOAD_INVOICE_BILL_ORDERS",
  RECEIPT_UPLOAD_ORDERS: "RECEIPT_UPLOADED_ORDERS",
  RECEIPT_BILL_UPLOAD_ORDERS: "RECEIPT_BILL_UPLOADED_ORDERS",
  MIRAKL_AWAITING_SHIPMENT_ORDERS: "MIRAKL_AWAITING_SHIPMENT_ORDERS",
  // Orders whose receipt/Beleg number is still missing ("Belegnummer fehlt").
  ORDER_RECEIPT_MISSING_ORDERS: "ORDER_RECEIPT_MISSING_ORDERS",
};

export const ORDER_TYPES = {
  EBAY: "ebay",
};

export const STEP_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  PENDING: "pending",
  FAILED: "failed",
  CANCEL: "cancel",
  INVOICE_RECEIPT_CREATED: "INVOICE_RECEIPT_CREATED",
  INVOICE_CREATED: "INVOICE_CREATED",
  IMPORTED: "IMPORTED",
};
export const STEP_BUTTON_VARIANTS = {
  OUTLINE: "outline",
  PRIMARY: "primary",
  NULL: "",
};

export const ORDER_STEP_BUTTONS = {
  BTN_CANCEL_ORDER: "btnCancelOrder",
  BTN_ACCEPT_ORDER: "btnAcceptOrder",
  BTN_CHANGE_BILLING_ADDRESS: "btnChangeBillingAddress",
  BTN_BILLING_ADDRESS_CORRECT: "btnBillingAddressCorrect",
  BTN_ENTER_CLUB_NUMBER: "btnEnterClubNumber",
  BTN_NO_CLUB_NUMBER: "btnNoClubNumber",
  BTN_CREATE_RECEIPT: "btnCreateReceipt",
  BTN_UPLOAD_RECEIPT: "btnUploadReceipt",
  BTN_UPLOAD_INVOICE_BILL: "btnUploadCustomerReceipt",
  BTN_SKIP_UPLOAD: "btnSkipUpload",
  BTN_CREATE_SHIPPING_LABEL: "btnCreateShippingLabel",
  BTN_ORDER_SHIPPED: "btnOrderShipped",
};

export const DOCUMENT_TYPES = {
  INVOICE: "invoice",
  RECEIPT: "receipt",
};

export const CARD_ACTION_TYPES = {
  SHOW_PREVIEW: "showPreview",
  INVOICE_PREVIEW: "invoicePreview",
  RECEIPT_PREVIEW: "receiptPreview",
};

export const ORDER_STEP_KEYS = {
  CREATE_INVOICE: "stepCreateInvoice",
  SCAN_RECEIPT: "stepScanReceipt",
};

export const ERROR_MESSAGES = {
  CREATE_INVOICE_FAILED: "Fehler beim Erstellen der Rechnung",
  UPLOAD_RECEIPT_FAILED: "Fehler beim Hochladen des Belegs",
  UPLOAD_INVOICE_FAILED: "Fehler beim Hochladen der Rechnung",
};

export const FILE_NAMES = {
  INVOICE: "invoice.pdf",
};

export const DATA_KEYS = {
  TIMESTAMP: "timestamp",
};

export const INVOICE_PROCESS_STATUS = {
  GENERATING: "generating",
  UPLOADING: "uploading",
  SUCCESS: "success",
  ERROR: "error",
};

export const UI_TEXT_KEYS = {
  INVOICE_IFRAME_TITLE: "invoicePdfPreview",
};

export const INVOICE_STATUS = {
  IDLE: "idle",
  GENERATING: "generating",
  UPLOADING: "uploading",
  UPDATING: "updating",
  SUCCESS: "success",
  ERROR: "error",
};

export const STEP_KEYS = {
  ACCEPT_ORDER: "stepAcceptOrder",
  CONFIRM_BILLING: "stepConfirmBillingAddress",
  CLUB_CUSTOMER: "stepClubCustomer",
  CREATE_INVOICE: "stepCreateInvoice",
  SCAN_RECEIPT: "stepScanReceipt",
  CREATE_SHIPPING_LABEL: "stepCreateShippingLabel",
  ENTER_TRACKING_NUMBER: "stepEnterTrackingNumber",
  ITEM_SHIPPED: "stepItemShipped",
  ITEM_PICKED_UP: "itemPickedUp",
  UPLOAD_RECEIPT: "stepUploadReceipt",
  UPLOAD_INVOICE_BILL: "stepUploadCustomerReceipt",
};

export const STEP_IDS = {
  [STEP_KEYS.ACCEPT_ORDER]: 1,
  [STEP_KEYS.CONFIRM_BILLING]: 2,
  [STEP_KEYS.CLUB_CUSTOMER]: 3,
  [STEP_KEYS.CREATE_INVOICE]: 4,
  [STEP_KEYS.SCAN_RECEIPT]: 5,
  [STEP_KEYS.CREATE_SHIPPING_LABEL]: 6,
  [STEP_KEYS.ITEM_SHIPPED]: 7,
};

export const STEP_BUTTONS = {
  CANCEL_ORDER: "BTN_CANCEL_ORDER",
  ACCEPT_ORDER: "BTN_ACCEPT_ORDER",
  BILLING_ADDRESS_CORRECT: "BTN_BILLING_ADDRESS_CORRECT",
  CHANGE_BILLING_ADDRESS: "BTN_CHANGE_BILLING_ADDRESS",
  ENTER_CLUB_NUMBER: "BTN_ENTER_CLUB_NUMBER",
  NO_CLUB_NUMBER: "BTN_NO_CLUB_NUMBER",
  CREATE_RECEIPT: "BTN_CREATE_RECEIPT",
  UPLOAD_RECEIPT: "BTN_UPLOAD_RECEIPT",
  CREATE_SHIPPING_LABEL: "BTN_CREATE_SHIPPING_LABEL",
  ORDER_SHIPPED: "BTN_ORDER_SHIPPED",
};

export const STEP_DIALOGS = {
  BILLING_ADDRESS: "billingAddress",
  CLUB_NUMBER: "clubNumber",
  INVOICE: "invoice",
};

export const ORDER_STATUS = {
  READY_TO_SHIP: "READY_TO_SHIP",
  WAITING_FOR_PICKUP: "WAITING_FOR_PICKUP",
  ORDER_ACCEPTED: "ORDER_ACCEPTED",
  CANCELLED: "CANCELLED",
  CANCELED: "CANCELED",
  BUYER_CANCELED: "BUYER_CANCELED",
  CLUB_NUMBER_COLLECTED: "CLUB_NUMBER_COLLECTED",
  INVOICE_RECEIPT_CREATED: "INVOICE_RECEIPT_CREATED",
  RECEIPT_COLLECTED: "RECEIPT_COLLECTED",
  SHIPPING_LABEL_CREATED: "SHIPPING_LABEL_CREATED",
  TRACKING_CODE_ADDED: "TRACKING_CODE_ADDED",
  TRACKING_SUCCESS: "TRACKING_SUCCESS",
  TRACKING_FAILED: "TRACKING_FAILED",
  COMPLETED: "COMPLETED",
  // Mirakl's status for the actual receipt-file upload step (distinct from
  // RECEIPT_COLLECTED, which is the confirm-only step)
  RECEIPT_UPLOADED: "RECEIPT_UPLOADED",
  // Mirakl's status for the invoice/bill upload step
  RECEIPT_BILL_COLLECTED: "RECEIPT_BILL_COLLECTED",
  PICKED_UP: "Abgeholt",
  PICKED_UP_EN: "PICKED_UP",
  EXTERNALLY_HANDLED: "EXTERNALLY_HANDLED",
  ORDER_RECEIPT_MISSING: "ORDER_RECEIPT_MISSING",
};

export const DE_ORDER_STATUS_DISPLAY = {
  READY_TO_SHIP: "Versandfertig",
  CANCELED: "Storniert",
  EXTERNALLY_HANDLED: "Extern bearbeitet",
  SHIPPED: "Verschickt",
};

export const SHIPPING_METHODS = {
  DHL_PAKET: "DE_DHLPaket",
  PICKUP: "DE_Pickup",
};

export const SHIPPING_METHOD_DISPLAY = {
  DHL_PAKET: "DHL-Paket",
  PICKUP: "Abholung",
};

export const CANCEL_REASONS = [
  { label: "addressIssues", value: "ADDRESS_ISSUES" },
  { label: "buyerAskedCancel", value: "BUYER_ASKED_CANCEL" },
  { label: "orderUnpaid", value: "ORDER_UNPAID" },
  {
    label: "outOfStockOrCannotFulfill",
    value: "OUT_OF_STOCK_OR_CANNOT_FULFILL",
  },
];

export const STATS_EXCLUDED_KEYS = ["outletId", "outletName"];

export const DHL_TRACKING_URL =
  "https://www.dhl.de/de/privatkunden/dhl-sendungsverfolgung.html?piececode=";

export const ORDER_CARD_TITLES = {
  LIEFERDATEN: "Lieferdaten",
  BELEGDATEN: "Belegdaten",
  RUECKGABEDATEN: "Rückgabedaten",
};
export const HARDCODED_ORDER_CARD_DATA = {
  Invalid_Request: "Invalid Request",
};

export const HARDCODED_TABLE_ITEM = {
  ITEM_NUMBER: "67814",
  NAME: "Versandkosten",
};

export const ADDRESS_CARD_TITLES = ["Lieferanschrift", "Rechnungsanschrift"];

export const SUPER_ADMIN_ONLY_TABLE_COLUMNS = [
  "outletId",
  "outletName",
  "outletSapName",
  "outletSapId",
];
